export default __webpack_public_path__ + "static/media/Front-Restaurant-Wedding-Venue-in-Deir-Al-Qamar.faa7a899.jpg";